module.exports = __webpack_public_path__ + "img/audio_close.0e2150a3.svg";